import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export const stateKey = new PluginKey('tasksAndDecisionsPlugin');
